import { Controller, useFormContext } from 'react-hook-form';

import { AvatarPickerProps } from '.';
import AvatarPicker from './AvatarPicker';

interface Props extends Omit<AvatarPickerProps, 'value' | 'onChange'> {
  name: string;
}

const FormAvatarPicker = ({ name, ...rest }: Props) => {
  const { control, setValue } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { onChange: _, ref, ...controllerField } = field;
        return (
          <AvatarPicker
            onChange={(value: string) =>
              setValue(name, value, { shouldDirty: true, shouldTouch: true, shouldValidate: true })
            }
            onRemove={() => setValue(name, null, { shouldDirty: true, shouldTouch: true, shouldValidate: true })}
            {...controllerField}
            {...rest}
          />
        );
      }}
    />
  );
};

FormAvatarPicker.displayName = 'FormAvatarPicker';

export default FormAvatarPicker;
